import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { useLocation, useParams } from "react-router-dom";

type UseCheckRenewVisaHistoryPageReturn = {
  isHistoryPage: boolean;
};

export const useCheckRenewVisaHistoryPage = (): UseCheckRenewVisaHistoryPageReturn => {
  const { employeeRenewVisaDocumentGroupId } = useParams();
  const location = useLocation();

  const isHistoryPage = location.pathname.startsWith(getDynamicRoute(AppRoutes.renewVisaInfoHistory, { employeeRenewVisaDocumentGroupId }));

  return { isHistoryPage };
};
